module.exports = __webpack_public_path__ + "assets/img/img195.b14ce496.png";